import { Badge, Button, Drawer, Flex, Popconfirm, Typography } from "antd";
import { BellOutlined, LogoutOutlined } from "@ant-design/icons";
import { UserSummary } from "./UserMenu";
import { neutral, spacing, typography } from "../../theme/tokens";

const { Text } = Typography;

/**
 * Drawer thông tin người dùng cho màn hẹp (nút hamburger ở Topbar).
 * Tách khỏi `HeaderConek` — nội dung y như cũ, chỉ đổi chỗ ở.
 */
export default function MobileUserDrawer({
  open,
  onClose,
  user,
  nameLabel,
  isCustomer,
  unreadCount,
  onOpenNotifications,
  onLogout,
}) {
  const info = user?.data;

  return (
    <Drawer title="Thông tin người dùng" placement="left" onClose={onClose} open={open}>
      <Flex vertical gap={spacing[4]}>
        <Flex align="center" justify="space-between" gap={spacing[3]}>
          <Flex align="center" gap={spacing[3]}>
            <UserSummary user={user} nameLabel={nameLabel} />
          </Flex>
          {isCustomer && (
            <Button type="text" onClick={onOpenNotifications}>
              <Badge count={unreadCount}>
                <BellOutlined style={{ fontSize: 17, verticalAlign: "middle" }} />
              </Badge>
            </Button>
          )}
        </Flex>

        <Flex vertical gap={spacing[2]}>
          <Text style={{ color: neutral[600], fontSize: typography.size.base }}>
            Email: {info?.email || "—"}
          </Text>
          <Text style={{ color: neutral[600], fontSize: typography.size.base }}>
            Số điện thoại: {info?.phone || "—"}
          </Text>
        </Flex>

        <Popconfirm
          title="Bạn có chắc chắn muốn đăng xuất?"
          onConfirm={onLogout}
          okText="Đồng ý"
          cancelText="Hủy"
        >
          <Button type="primary" danger icon={<LogoutOutlined />}>
            Đăng xuất
          </Button>
        </Popconfirm>
      </Flex>
    </Drawer>
  );
}
